var actions = {
	next: "Siguiente",
	confirm: "Confirmar",
	"continue": "Continuar"
};
var errors = {
	unknown: "Se ha producido un error desconocido",
	contactSupport: "Se ha producido un error. Contacta con el servicio de asistencia.",
	tryAgain: "Se ha producido un error. Vuelve a intentarlo.",
	submit: "Se produjo un error con tu envío."
};
var brands = {
	apple: "Apple",
	facebook: "Facebook",
	google: "Google",
	paypal: "PayPal",
	picarto: "Picarto",
	tiktok: "TikTok",
	trovo: "Trovo",
	twitch: "Twitch",
	youtube: "YouTube",
	twitter: "X (Twitter)",
	linkedin: "LinkedIn",
	streamlabs: "Streamlabs",
	mevo: "Mevo",
	typestudio: "TypeStudio"
};
var loginButton = {
	loginWith: "Iniciar sesión con {name}",
	signupWith: "Registrarse con {name}"
};
var alreadyHaveAccount = {
	company: "¿Ya tienes una cuenta de {company}?",
	text: "¿Ya tienes un Streamlabs ID?",
	link: "Iniciar sesión"
};
var noAccount = {
	text: "¿Todavía no tienes una cuenta?",
	link: "Registrarse"
};
var validation = {
	email: {
		invalid: "Introduce una dirección de correo electrónico válida"
	},
	password: {
		required: "La contraseña es obligatoria",
		min: "La contraseña debe tener más de 8 caracteres",
		number: "La contraseña debe tener un número",
		upper: "La contraseña debe tener un carácter en mayúscula",
		special: "La contraseña debe tener un carácter especial"
	},
	username: {
		invalid: "El nombre debe tener por lo menos 5 caracteres."
	},
	code: {
		minmax: "El código debe tener entre 6 y 10 caracteres"
	}
};
var poweredBy = "Con tecnología de <company>Streamlabs</company>";
var card = {
	"404": {
		title: "¡No se encontró la empresa!",
		desc: "Vuelve a intentarlo más tarde o contacta con asistencia."
	},
	company: {
		logoAlt: "Logotipo de {company}"
	}
};
var checkTfaForm = {
	tfaCodePlaceholder: "Código de autorización de 6 dígitos/Código de copia de seguridad de 8 dígitos",
	successText: "¡Correcto! Redirigiendo...",
	remember: "Recordar este dispositivo durante 30 días"
};
var createTfa = {
	scan: {
		title: "Activar autenticación de dos factores",
		lead: "Haz clic, copia o escanea el código a continuación con tu aplicación de autenticación preferida Recomendamos el uso de una aplicación como <app0 />, <app1 /> o <app2 /> para guardar los códigos de forma segura.",
		copied: "¡Se ha copiado!",
		instructions: "O introduce manualmente este código en tu aplicación de autenticación.",
		copy: "Copiar código",
		proceed: "Confirmación"
	},
	confirm: {
		title: "Confirma tu autenticación de dos factores",
		lead: "Envía un código de autorización de dos factores a continuación para confirmar y activar la autenticación de dos factores.",
		label: "Código de autenticación de dos factores (6 dígitos)",
		verify: "Verificar código",
		next: "¡Correcto! Siguiente paso"
	},
	save: {
		title: "Guarda tus códigos de recuperación",
		lead: "Guarda tus códigos de recuperación a continuación por si pierdes acceso a tu autenticador de dos factores. Después de cerrar este modal, estos códigos no volverán a estar disponibles.",
		label: "Códigos de recuperación",
		download: "Descargar códigos de recuperación",
		copied: "¡Códigos copiados!",
		finished: "Finalizado"
	}
};
var emailLoginForm = {
	buttonText: "Iniciar sesión",
	emailPlaceholder: "Correo electrónico",
	passwordPlaceholder: "Contraseña"
};
var emailSignupForm = {
	buttonText: "Registrarse",
	emailPlaceholder: "Establecer un correo electrónico",
	passwordPlaceholder: "Establecer una contraseña",
	usernamePlaceholder: "Tu nombre",
	ageLabel: "Fecha de nacimiento",
	agePlaceholder: "DD/MM/AAAA",
	agreeText: "Acepto los <terms>Términos de servicio</terms> y la <privacy>Política de privacidad</privacy> de Streamlabs.",
	agreeError: "Acepta los términos y condiciones de Streamlabs"
};
var ageInput = {
	invalidDate: "Introduce una fecha de cumpleaños válida",
	futureDate: "Debes introducir una fecha de nacimiento en el pasado",
	minDate: "No se admiten fechas anteriores al año {year}",
	minAge_one: "Debes tener {years} año o más para utilizar Streamlabs",
	minAge_two: "Debes tener {years} años o más para utilizar Streamlabs",
	minAge_other: "Debes tener {years} años o más para utilizar Streamlabs"
};
var forgotPasswordForm = {
	emailPlaceholder: "Correo electrónico",
	back: "Volver a inicio de sesión",
	successText: "¡Correcto! Te lo hemos enviado con un código de restablecimiento de contraseña",
	buttonText: "Solicitar correo electrónico de restablecimiento",
	create: {
		successText: "¡Correcto! ¡Te hemos enviado un código de verificación para que puedas empezar!",
		buttonText: "Solicitar código de verificación"
	},
	errors: {
		notFound: "No se encontró ninguna cuenta con este correo electrónico"
	}
};
var forgotPasswordCard = {
	forgot: {
	},
	title: "¿Has olvidado tu contraseña?",
	lead: "Si necesitas restablecer tu contraseña, escribe a continuación tu dirección de correo electrónico y te enviaremos un correo electrónico para iniciar el proceso.",
	resetTitle: "Restablecer tu contraseña",
	resetLead: "Deberías haber recibido un código por correo electrónico. Completa el formulario para restablecer tu contraseña.",
	create: {
		title: "Crear tu contraseña",
		lead: "¡Enhorabuena por crear tu Streamlabs ID! ¡Un paso más y podrás iniciar sesión en todo Streamlabs!",
		resetTitle: "Elegir una contraseña",
		resetLead: "Deberías haber recibido un código por correo electrónico. Úsalo y completa el formulario para configurar tu contraseña."
	},
	successText: "¡Correcto! Redirigiendo...",
	signInTitle: "¿Ya tienes una cuenta?",
	signInBtn: "Iniciar sesión"
};
var checkTfaCard = {
	title: "Comprobación de autenticación de dos factores",
	lead: "Introduce a continuación un código de autenticación de dos factores para continuar.",
	successText: "¡Autorización de dos factores confirmada correctamente!",
	back: "Regresar"
};
var verifyEmailCard = {
	title: "Verificar tu correo electrónico",
	lead: "Busca en tu correo electrónico un código de 8 dígitos de Streamlabs e introdúcelo a continuación.",
	back: "Regresar",
	successText: "¡Correo electrónico verificado correctamente!"
};
var upgradeCard = {
	confirm: {
		title: "Confirmar conexión a {company}",
		userLine: "<b>Streamlabs ID</b> {email}",
		items: [
			"A partir de ahora podrás iniciar sesión en {company} con el correo electrónico y la contraseña proporcionados.",
			"Puedes acceder a todos los demás productos de Streamlabs con tu ID y conectar otras cuentas existentes si las tienes.",
			"Tu cuenta de {company} no se verá afectada por este cambio."
		],
		button: "Confirmar",
		cancel: "Cancelar",
		switchAccount: "Cambiar cuenta",
		success: "Conectando..."
	},
	confirmed: {
		title: "¡Correcto!",
		subtitle: "Se ha creado tu Streamlabs ID y la cuenta de {company} está conectada.",
		text: "Puedes usar tu Streamlabs ID para todos los productos Streamlabs. Si tienes cuentas existentes, puedes conectarlas a este ID desde cada aplicación.",
		button: "Cerrar"
	},
	error: {
		user: "Error de identificación de usuario. Vuelve a iniciar sesión o contacta con asistencia."
	}
};
var confirmCard = {
	confirm: {
		title: "Confirmar conexión a {company}",
		subtitle: "Encontramos una cuenta con un correo electrónico que coincide. ¿Quieres combinar esta cuenta con Streamlabs ID?",
		userLine: "<b>Streamlabs ID</b> {email}",
		items: [
			"Podrás iniciar sesión en {company} con el correo electrónico y la contraseña que proporcionaste mediante Streamlabs ID.",
			"Puedes acceder a todos los demás productos de Streamlabs con tu ID y conectar otras cuentas existentes si las tienes.",
			"Tu cuenta de empresa no se verá afectada por este cambio."
		],
		button: "Confirmar",
		cancel: "Cancelar",
		switchAccount: "Cambiar cuenta",
		success: "Conectando..."
	},
	confirmed: {
		title: "¡Correcto!",
		subtitle: "Se ha creado tu Streamlabs ID y la cuenta de {company} está conectada.",
		text: "Puedes usar tu Streamlabs ID para todos los productos Streamlabs. Si tienes cuentas existentes, puedes conectarlas a este ID desde cada aplicación.",
		button: "Cerrar"
	},
	error: {
		user: "Error de identificación de usuario. Vuelve a iniciar sesión o contacta con asistencia."
	}
};
var upgradeConfirmCard = {
	confirm: {
		title: " Tu ID ya tiene conectado una cuenta de {company}",
		subtitle: "¿Quieres desvincular la cuenta conectada y vincular tu cuenta actual de Streamlabs?",
		userLine: "<b>Streamlabs ID</b> {email}",
		items: [
			"Podrás iniciar sesión en Streamlabs con el correo electrónico y la contraseña que proporcionaste mediante Streamlabs ID.",
			"Puedes acceder a todos los demás productos de Streamlabs con tu ID y conectar otras cuentas existentes si las tienes.",
			"Tu cuenta de Streamlabs no se verá afectada por este cambio."
		],
		button: "Confirmar",
		cancel: "Cancelar",
		switchAccount: "Cambiar cuenta",
		success: "Conectando...",
		agreeLabel: "Comprendo que al realizar esta conexión, perderé el acceso a la cuenta de {company} existente vinculada a Streamlabs ID."
	},
	confirmed: {
		title: "¡Correcto!",
		subtitle: "Se ha creado tu Streamlabs ID y la cuenta de {company} está conectada.",
		text: "Puedes usar tu Streamlabs ID para todos los productos Streamlabs. Si tienes cuentas existentes, puedes conectarlas a este ID desde cada aplicación.",
		button: "Cerrar"
	},
	error: {
		user: "Error de identificación de usuario. Vuelve a iniciar sesión o contacta con asistencia."
	}
};
var loginCard = {
	title: "Iniciar sesión",
	lead: "Inicia sesión en <company>{company}</company> con <id>Streamlabs ID</id>",
	accountExists: "Parece que tienes un <b>Streamlabs ID</b>. Trata de iniciar sesión con tu correo electrónico.",
	forgotPassword: "¿Has olvidado tu contraseña?",
	successText: "¡Correcto! Redirigiendo...",
	signInTitle: "Iniciar sesión con una plataforma"
};
var loginSourcesCard = {
	title: "Iniciar sesión",
	lead: "Iniciar sesión con correo electrónico/contraseña",
	withSlId: "Iniciar sesión con Streamlabs ID",
	noAccountMessage: "No vemos una cuenta asociada con este método de inicio de sesión. Prueba un método de inicio de sesión diferente o <signup>Regístrate</signup> si no lo has hecho todavía.",
	accountExistsMessage: "Tu dirección de correo electrónico de Twitch ya está asociada con Streamlabs. Trata de iniciar sesión con un correo electrónico y contraseña de Streamlabs."
};
var resetPasswordForm = {
	emailPlaceholder: "Correo electrónico",
	codePlaceholder: "Código de correo electrónico de 6-8 dígitos",
	tfaCodePlaceholder: "Código de autenticación de dos factores",
	newPasswordPlaceholder: "Nueva contraseña",
	tfaError: "El código de restablecimiento debe tener entre 6 y 10 caracteres",
	next: "¿Recibiste el código?",
	back: "Volver a ¿Has olvidado tu contraseña?",
	buttonText: "Cambiar contraseña",
	successText: "Contraseña restablecida correctamente",
	create: {
		back: "Volver al inicio",
		buttonText: "Establecer contraseña",
		successText: "Contraseña establecida correctamente"
	}
};
var changePasswordForm = {
	currentPasswordPlaceholder: "Contraseña actual",
	newPasswordPlaceholder: "Nueva contraseña",
	newPasswordConfirmationPlaceholder: "Confirmar nueva contraseña",
	buttonText: "Cambiar contraseña",
	successText: "Contraseña actualizada correctamente",
	newPasswordConfirmationError: "Las nuevas contraseñas no coinciden",
	back: "Volver a panel"
};
var changePasswordCard = {
	title: "Cambiar contraseña",
	lead: "Introduce tu contraseña actual junto con una nueva contraseña a continuación.",
	successText: "Contraseña actualizada correctamente"
};
var removeTfaForm = {
	tfaCodePlaceholder: "Código de autorización de 6 dígitos/Código de copia de seguridad de 8 dígitos",
	successText: "Autorización de dos factores quitada correctamente",
	removeBtn: "Confirmar y quitar"
};
var removeTfaCard = {
	title: "Eliminar autenticación de dos factores",
	lead: "Introduce a continuación un código de confirmación de autenticación de dos factores para quitar la autenticación de dos factores de tu cuenta.",
	successText: "Autorización de dos factores quitada correctamente",
	back: "Volver a panel"
};
var verifyEmailForm = {
	codePlaceholder: "Código de 8 dígitos de correo electrónico",
	tfaCodePlaceholder: "Código de autenticación de dos factores",
	emailPlaceholder: "Dirección de correo electrónico",
	buttonText: "Verificar correo electrónico",
	successText: "Correo electrónico verificado correctamente",
	requestBtn: "Solicitar nuevo código",
	requestingBtn: "Solicitando...",
	requestSuccess: "Se ha enviado un código a tu correo electrónico",
	requestAgain: "Volver a solicitar en {seconds} s",
	tfaError: "El código de restablecimiento debe tener entre 6 y 10 caracteres",
	back: "Regresar"
};
var signupCard = {
	title: "Registrarse",
	lead: "Crea una cuenta de <id>Streamlabs ID</id> para usar <company>{company}</company>",
	successText: "¡Correcto! Redirigiendo..."
};
var signupSourcesCard = {
	title: "Registrarse",
	lead: "Crea una cuenta de <id>Streamlabs ID</id> para usar <company>{company}</company>",
	withSlId: "Crear un Streamlabs ID"
};
var connectCard = {
	connect: {
		title: "Elige una cuenta",
		lead: "para continuar a <b>{company}</b>",
		authorize: "Autorizar",
		authorizeSuccess: "¡Correcto!",
		cancel: "Cancelar",
		disclaimer: {
			streamlabs: "Al continuar, se compartirá tu Streamlabs ID (nombre, dirección de correo electrónico, preferencia de idioma e imagen de perfil) con <b>{company}</b>. Al autorizar una cuenta con <b>{company}</b>, acepta de <b>{company}</b> su <privacy>política de privacidad</privacy> y sus <terms>términos de servicio</terms>.",
			"default": "Para continuar, Streamlabs compartirá tu nombre, dirección de correo electrónico, preferencia de idioma e imagen de perfil con <b>{company}</b>. Al autorizar una cuenta con <b>{company}</b>, acepta de <b>{company}</b> su <privacy>política de privacidad</privacy> y sus <terms>términos de servicio</terms>."
		},
		emailRequired: "Antes de proseguir se requiere verificación de correo electrónico",
		tfaRequired: "Antes de proseguir se requiere autenticación de dos factores"
	},
	login: {
		title: "Iniciar sesión en {company}",
		lead: "Debes tener una sesión iniciada para conectar cuentas",
		loginBtn: "Continuar a inicio de sesión"
	},
	error: {
		title: "Iniciar sesión en {company}",
		lead: "No se pudo autorizar tu solicitud en este momento.",
		verifyEmail: "Verificar correo electrónico",
		verify2fa: "Verificar autenticación de dos factores"
	},
	"switch": {
		btn: "Usar otra cuenta"
	}
};
var appsDropdown = {
	label: "Productos y aplicaciones de Streamlabs",
	viewMore: "Expandir",
	viewLess: "Contraer"
};
var platformButtons = {
	loginWithPlatform: "Iniciar sesión con una plataforma",
	signUpWithPlatform: "Registrarse con una plataforma",
	signUpLead: "Admitimos el streaming en tiempo real a muchas más plataformas, estas son solo las opciones de registro."
};
var ultraCheckoutCard = {
	title: "Optimiza tu streaming en tiempo real, marca, edición y mucho más con <b>Streamlabs Ultra</b>",
	badge: "Incluye <b>{planName}</b>",
	totalValue: "valor de {price, currency}",
	price: {
		month: "{price, currency}/mes",
		year: "{price, currency}/año"
	},
	description: {
		month: "Accede a las funciones premium de toda la suite, incluidos <b>Streamlabs Desktop</b>, <b>Console</b>, <b>Talk Studio</b>, <b>Podcast Editor</b>, <b>Cross Clip</b>, y mucho más, disponible a un precio accesible.",
		year: "Accede a las funciones premium de toda la suite, incluidos <b>Streamlabs Desktop</b>, <b>Console</b>, <b>Talk Studio</b>, <b>Podcast Editor</b>, <b>Cross Clip</b>, y mucho más, disponible a un precio accesible."
	},
	seeIncluded: "Más información",
	buyNow: "Mejorar plan"
};
var ultraCheckoutBanner = {
	title: "Optimiza tu streaming en tiempo real, marca, edición y mucho más con <b>Streamlabs Ultra</b>",
	badge: "Incluye <b>{planName}</b>",
	totalValue: "valor de {price, currency}",
	price: {
		month: "{price, currency}/mes",
		year: "{price, currency}/año"
	},
	description: {
		month: "Accede a las funciones premium de toda la suite, incluidos <b>Streamlabs Desktop</b>, <b>Console</b>, <b>Talk Studio</b>, <b>Podcast Editor</b>, <b>Cross Clip</b>, y mucho más, disponible a un precio asequible. <link />",
		year: "Accede a las funciones premium de toda la suite, incluidos <b>Streamlabs Desktop</b>, <b>Console</b>, <b>Talk Studio</b>, <b>Podcast Editor</b>, <b>Cross Clip</b>, y mucho más, disponible a un precio asequible. <link />"
	},
	seeIncluded: "Más información",
	buyNow: "Mejorar plan"
};
var connect = {
	waitMessage: "Combinando datos. No cierres esta ventana."
};
var verifyPasswordCard = {
	success: "Contraseña verificada correctamente",
	title: "Vuelve a autentificar para verificar",
	lead: "Inicia sesión con tu correo electrónico y contraseña actuales para seguir actualizando tu Streamlabs ID.",
	buttonText: "Siguiente"
};
var emailChangeForm = {
	agreeError: "Comprueba que entiendes esta acción",
	buttonText: "Siguiente",
	emailPlaceholder: "Nueva dirección de correo electrónico",
	agreeText: "Entiendo que una vez verificado, mi Streamlabs ID cambiará en todos los productos de Streamlabs a los que me haya conectado."
};
var verifyNewEmailCard = {
	title: "Cambia tu Streamlabs ID",
	lead: "Proporciona un nuevo correo electrónico para utilizarlo como tu Streamlabs ID. Enviaremos un código de verificación de 6-8 dígitos a esta dirección.",
	successText: "Nuevo correo electrónico disponible"
};
var verifyNewEmailOwnershipCard = {
	title: "Verifica tu Streamlabs ID actualizado",
	lead: "Busca en tu correo electrónico un código de 8 dígitos de Streamlabs e introdúcelo a continuación.",
	buttonText: "Confirmar",
	back: "Atrás",
	codePlaceholder: "Código de 8 dígitos del correo electrónico",
	successText: "Propiedad de la cuenta de correo electrónico verificada correctamente"
};
var verifyTfaCard = {
	title: "Código de autenticación de 2 factores",
	lead: "Introduce el código de verificación de 6 dígitos que aparece en tu aplicación de autenticación.",
	codePlaceholder: "Código de 6 dígitos",
	buttonText: "Confirmar",
	successText: "Autenticación de 2 factores confirmada",
	back: "Atrás"
};
var ageGateForm = {
	ageLabel: "Fecha de nacimiento",
	agePlaceholder: "DD/MM/AAAA"
};
var ageGateCard = {
	title: "Completar la configuración de la cuenta",
	lead: {
		years: "Debes ser mayor de {years} para crear una cuenta. <br />Introduce tu fecha de nacimiento para finalizar la configuración.",
		noYears: "Debes indicar tu fecha de nacimiento para crear una cuenta. <br />Introdúcelo para finalizar la configuración."
	},
	successText: "¡Enhorabuena! Configuración de la cuenta completada."
};
var esES = {
	actions: actions,
	errors: errors,
	brands: brands,
	loginButton: loginButton,
	alreadyHaveAccount: alreadyHaveAccount,
	noAccount: noAccount,
	validation: validation,
	poweredBy: poweredBy,
	card: card,
	checkTfaForm: checkTfaForm,
	createTfa: createTfa,
	emailLoginForm: emailLoginForm,
	emailSignupForm: emailSignupForm,
	ageInput: ageInput,
	forgotPasswordForm: forgotPasswordForm,
	forgotPasswordCard: forgotPasswordCard,
	checkTfaCard: checkTfaCard,
	verifyEmailCard: verifyEmailCard,
	upgradeCard: upgradeCard,
	confirmCard: confirmCard,
	upgradeConfirmCard: upgradeConfirmCard,
	loginCard: loginCard,
	loginSourcesCard: loginSourcesCard,
	resetPasswordForm: resetPasswordForm,
	changePasswordForm: changePasswordForm,
	changePasswordCard: changePasswordCard,
	removeTfaForm: removeTfaForm,
	removeTfaCard: removeTfaCard,
	verifyEmailForm: verifyEmailForm,
	signupCard: signupCard,
	signupSourcesCard: signupSourcesCard,
	connectCard: connectCard,
	appsDropdown: appsDropdown,
	platformButtons: platformButtons,
	ultraCheckoutCard: ultraCheckoutCard,
	ultraCheckoutBanner: ultraCheckoutBanner,
	connect: connect,
	verifyPasswordCard: verifyPasswordCard,
	emailChangeForm: emailChangeForm,
	verifyNewEmailCard: verifyNewEmailCard,
	verifyNewEmailOwnershipCard: verifyNewEmailOwnershipCard,
	verifyTfaCard: verifyTfaCard,
	ageGateForm: ageGateForm,
	ageGateCard: ageGateCard
};

export { esES as e };
//# sourceMappingURL=es-ES.es.js.map
